// extracted by css-extract-rspack-plugin
export default {"bucket":"Bucket-module__bucket--QDjZF","black-background":"Bucket-module__black-background--KRzx0","item-count":"Bucket-module__item-count--mqCWV"};